import {
  get,
  post
} from './http'

export default {
  // 变更班次
  changeFrequency(openid, orderid, infoid, oldfreid, newfreid) {
    return post('UserOrder/changeFrequency', {
      openid: openid,
      orderid: orderid,
      infoid: infoid,
      oldfreid: oldfreid,
      newfreid: newfreid
    });
  },

  //生成车票订单
  // createTicketOrder(openid, geton, getoff, frearr, contact, extraservice = "", location = '', flynum = '', isfreeticket =
  //   false, flightordernum = '') {
  //   return post('UserOrder/WeChatMiniCreateOrder2', {
  //     openid: openid,
  //     geton: geton,
  //     getoff: getoff,
  //     frearr: frearr,
  //     contact: contact,
  //     extraservice: extraservice,
  //     location: location,
  //     flynum: flynum,
  //     isfreeticket: isfreeticket,
  //     flightordernum: flightordernum
  //   });
  // },
  createTicketOrderV2(openid, ordertype, geton, getoff, frearr, contact, district, address, mobile, ordercontact,lugcount, isrental, ispackage, extraservice, location, flynum, flightordernum,purpose) {
    return post('UserOrder/CreateTicketOrder', {
      openid: openid,
      ordertype: ordertype,
      geton: geton,
      getoff: getoff,
      freid: frearr[0].ID,
      province: "广东省",
      city: "中山市",
      district: district,
      address: address,
      mobile: mobile,
      ordercontact: ordercontact,
      contact: contact,
      lugcount: lugcount,
      extraservice: extraservice,
      location: location,
      flynum: flynum,
      isrental: isrental,
      ispackage: ispackage,
      flightordernum: flightordernum,
      purpose: purpose,
    });
  },

  //生成返程车票订单
  createBackTicketOrder(openid, geton, getoff, setdate, contact, extraservice = "", location = '', flynum = '',
    isfreeticket =
    false, flightordernum = '') {
    return post('UserOrder/WeChatCreateBackTicketOrder', {
      openid: openid,
      geton: geton,
      getoff: getoff,
      setdate: setdate,
      contact: contact,
      extraservice: extraservice,
      location: location,
      flynum: flynum,
      isfreeticket: isfreeticket,
      flightordernum: flightordernum
    });
  },

  // 创建商城订单
  createScopeOrder(submitData) {
    return post('ScopeOrder/createScopeOrder', submitData);
  },

  //创建接送车订单
  createPickupTicketOrder(openid, geton, getoff, frearr, contact, district, districtprice, address,
    mobile, ordercontact, lugcount, extraservice = "", location = '', flynum = '') {
    return post('UserOrder/WeChatMiniCreatePickupOrder2', {
      openid: openid,
      geton: geton,
      getoff: getoff,
      frearr: frearr,
      province: "广东省",
      city: "中山市",
      district: district,
      districtprice: districtprice,
      address: address,
      mobile: mobile,
      ordercontact: ordercontact,
      contact: contact,
      lugcount: lugcount,
      extraservice: extraservice,
      location: location,
      flynum: flynum
    });
  },

  //获取车票订单列表
  getTicketOrderList(openid, page, count) {
    return get('UserOrder/getUserOrderList', {
      openid: openid,
      page: page,
      count: count
    });
  },

  //获取商城订单列表
  getScopeOrderList(openid, page, count) {
    return get('ScopeOrder/getUserScopeOrderList', {
      openid: openid,
      page: page,
      count: count
    });
  },

  getAppointOrderList(openid, page, count) {
    return get('AppointOrder/getUserAppointOrderList', {
      openid: openid,
      page: page,
      count: count
    });
  },

  //用户取消车票订单
  userCancelTicketOrder(openid, id) {
    return post('UserOrder/userInvalidOrder', {
      openid: openid,
      id: id
    });
  },

  //用户取消商城订单
  userCancelScopeOrder(openid, id) {
    return post('ScopeOrder/userCancleScopeOrder', {
      openid: openid,
      id: id
    });
  },

  // 用户取消约车订单
  userCancelAppointOrder(openid, id) {
    return post('AppointOrder/cancelAppointOrder', {
      openid: openid,
      id: id
    });
  },

  //获取车票订单信息
  getTicketOrderInfo(openid, id) {
    return post('UserOrder/getUserOrder', {
      openid: openid,
      id: id
    });
  },

  //获取商城订单信息
  getScopetOrderInfo(openid, id) {
    return post('ScopeOrder/getUserScopeOrderInfo', {
      openid: openid,
      id: id
    });
  },
  // 获取约车订单信息
  getAppointOrderInfo(openid, id) {
    return post('AppointOrder/getUserAppointOrderInfo', {
      openid: openid,
      id: id
    });
  },
  //用户OpenId, contact联系人姓名, business商户标识, markname商户地标, membercount乘车人数, luggagecount行李件数, bookingDate预约时间, serviceType服务类型, riderPhone乘车人联系电话, district城镇区, bookingEndAddr用户地址, city城市, estimatedAmount预估金额, remarks备注, isGo是否去程(0:1)

  //创建商户预约车订单
  createBusinessAppointOrder(openid, contact, business, markname, membercount, luggagecount, bookingDate, serviceType,
    riderPhone, district, bookingEndAddr, bookingEndPointLa, bookingEndPointLo, city, estimatedAmount, remarks, isGo,
    limit, location = '', fromparams = '') {
    return post('AppointOrder/CreateBusinessAppointOrder', {
      openid: openid,
      contact: contact,
      business: business,
      markname: markname,
      membercount: membercount,
      luggagecount: luggagecount,
      bookingDate: bookingDate,
      serviceType: serviceType,
      riderPhone: riderPhone,
      district: district,
      bookingEndAddr: bookingEndAddr,
      bookingEndPointLa: bookingEndPointLa,
      bookingEndPointLo: bookingEndPointLo,
      city: city,
      estimatedAmount: estimatedAmount,
      remarks: remarks,
      isGo,
      limit: limit,
      location: location,
      fromparams: fromparams
    });
  },

  //用户OpenId, contact联系人姓名, business商户标识, markname商户地标, membercount乘车人数, luggagecount行李件数, bookingDate预约时间, serviceType服务类型, riderPhone乘车人联系电话, district城镇区, bookingEndAddr用户地址, city城市, estimatedAmount预估金额, remarks备注, isGo是否去程(0:1)

  //创建商户预约车订单
  createBusinessAppointOrder2(openid, contact, business, markname, membercount, luggagecount, bookingDate, serviceType,
    riderPhone, district, bookingEndAddr, bookingEndPointLa, bookingEndPointLo, city, estimatedAmount, remarks, isGo,
    limit, isrental, location = '', fromparams = '') {
    return post('AppointOrder/CreateBusinessAppointOrder2', {
      openid: openid,
      contact: contact,
      business: business,
      markname: markname,
      membercount: membercount,
      luggagecount: luggagecount,
      bookingDate: bookingDate,
      serviceType: serviceType,
      riderPhone: riderPhone,
      district: district,
      bookingEndAddr: bookingEndAddr,
      bookingEndPointLa: bookingEndPointLa,
      bookingEndPointLo: bookingEndPointLo,
      city: city,
      estimatedAmount: estimatedAmount,
      remarks: remarks,
      isGo,
      limit: limit,
      isrental: isrental,
      location: location,
      fromparams: fromparams
    });
  },

  //用户OpenId, contact联系人姓名, business商户标识, markname商户地标, membercount乘车人数, luggagecount行李件数, bookingDate预约时间, serviceType服务类型, riderPhone乘车人联系电话, district城镇区, bookingEndAddr用户地址, city城市, estimatedAmount预估金额, remarks备注, isGo是否去程(0:1)

  //创建商户预约车订单
  createBusinessAppointOrderNew(openid, contact, business, markname, membercount, luggagecount, bookingDate,
    serviceType,
    riderPhone, district, bookingEndAddr, bookingEndPointLa, bookingEndPointLo, city, estimatedAmount, remarks, isGo,
    limit, isrental, location = '', fromparams = '') {
    return post('AppointOrder/CreateBusinessAppointOrderNew', {
      openid: openid,
      contact: contact,
      business: business,
      markname: markname,
      membercount: membercount,
      luggagecount: luggagecount,
      bookingDate: bookingDate,
      serviceType: serviceType,
      riderPhone: riderPhone,
      district: district,
      bookingEndAddr: bookingEndAddr,
      bookingEndPointLa: bookingEndPointLa,
      bookingEndPointLo: bookingEndPointLo,
      city: city,
      estimatedAmount: estimatedAmount,
      remarks: remarks,
      isGo,
      limit: limit,
      isrental: isrental,
      location: location,
      fromparams: fromparams
    });
  },
  CreateBusinessAppointOrderNewHtml(openid, contact, business, markname, membercount, luggagecount, bookingDate,
    serviceType,
    riderPhone, district, bookingEndAddr, bookingEndPointLa, bookingEndPointLo, city, estimatedAmount, remarks, isGo,
    limit, isrental, location = '', fromparams = '') {
    return post('AppointOrder/CreateBusinessAppointOrderNewHtml', {
      openid: openid,
      contact: contact,
      business: business,
      markname: markname,
      membercount: membercount,
      luggagecount: luggagecount,
      bookingDate: bookingDate,
      serviceType: serviceType,
      riderPhone: riderPhone,
      district: district,
      bookingEndAddr: bookingEndAddr,
      bookingEndPointLa: bookingEndPointLa,
      bookingEndPointLo: bookingEndPointLo,
      city: city,
      estimatedAmount: estimatedAmount,
      remarks: remarks,
      isGo,
      limit: limit,
      isrental: isrental,
      location: location,
      fromparams: fromparams
    });
  },
  getTicketTotalPrice(ordertype, freid, district, lugcount, address = '', isrental = false, contactlist = [],
    isfreeticket = false, geton, getoff, flightordernum = '') {
    return post('UserOrder/getTicketTotalPriceV2', {
      ordertype: ordertype,
      freid: freid,
      district: district,
      lugcount: lugcount,
      contactlist: contactlist,
      address: address,
      isrental: isrental,
      isfreeticket: isfreeticket,
      flightordernum: flightordernum,
      geton: geton,
      getoff: getoff,
    });
  },

  //创建接送车订单
  createPickupTicketOrderV2(openid, geton, getoff, frequencyId, contact, district, address, mobile, ordercontact,
    lugcount, isrental = false, extraservice = "", location = '', flynum = '', isfreeticket = false, flightordernum =
    '') {
    return post('UserOrder/WeChatMiniCreatePickupOrder', {
      openid: openid,
      geton: geton,
      getoff: getoff,
      freid: frequencyId,
      province: "广东省",
      city: "中山市",
      district: district,
      address: address,
      mobile: mobile,
      ordercontact: ordercontact,
      contact: contact,
      lugcount: lugcount,
      extraservice: extraservice,
      location: location,
      flynum: flynum,
      isrental: isrental,
      isfreeticket: isfreeticket,
      flightordernum: flightordernum
    });
  },
  // 专车下单
  createSpecialCarOrder(OpenId, GetOn, District, Province, City, Address, OrderContact, Mobile, LuggageCount,
    MemberCount, FlightNumber, SetDate, Price, Count, Remarks, Location, GetOff, FreId) {
    return post('UserOrder/WeChatMiniCreateAppointBackOrder', {
      openid: OpenId,
      geton: GetOn,
      district: District,
      province: Province,
      city: City,
      address: Address,
      ordercontact: OrderContact,
      mobile: Mobile,
      lugcount: LuggageCount,
      membercount: MemberCount,
      flightnum: FlightNumber,
      setdate: SetDate,
      price: Price,
      count: Count,
      remarks: Remarks,
      location: Location,
      getoff: GetOff,
      freid: FreId
    });
  },

  GetOrderStatistics(startdate, modelid) {
    return post('UserOrder/GetOrderStatistics', {
      startdate: startdate,
      modelid: modelid,
    });
  },

  getBusLineModelList() {
    return get('Frequency/getBusLineModelList',{
      token: 1,
    });
  },



}



// WEBPACK FOOTER //
// ./src/request/orderApi.js